import { useOnrApi } from '@/api/mutation/useOnrApi'

export function usePromotionReport() {
  return useOnrApi<string, { regionId?: string }>({
    type: 'promotionReport',
  })
}
